import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// Import English translations synchronously to prevent flash
import enTranslations from "./locales/en.json";

// Lazy-load secondary languages only
const loadResources = async (lng: string) => {
  switch (lng) {
    case "nl":
      return import("./locales/nl.json");
    case "de":
      return import("./locales/de.json");
    case "fr":
      return import("./locales/fr.json");
    default:
      return null; // English already loaded
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "nl", "de", "fr"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    // Pre-load English translations
    resources: {
      en: {
        translation: enTranslations,
      },
    },
  });

// Load secondary language resources when language changes
i18n.on("languageChanged", async (lng) => {
  if (lng !== "en" && !i18n.hasResourceBundle(lng, "translation")) {
    const module = await loadResources(lng);
    if (module) {
      i18n.addResourceBundle(lng, "translation", module.default);
    }
  }
});

export default i18n;
